import { render, staticRenderFns } from "./CommonManage.vue?vue&type=template&id=242dbc23&"
import script from "./CommonManage.vue?vue&type=script&lang=js&"
export * from "./CommonManage.vue?vue&type=script&lang=js&"
import style0 from "./CommonManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports